import { IUser } from '../common/model/user.model';
import { IJwtInfo } from '../common/model/jwtInfo.model';
import { ICompany } from '../common/model/company.model';
import { ReportCustomFieldSettingType } from '../common/model/enumerations/reportCustomFieldSettingType.model';
import { UserType } from '../common/model/enumerations/userType.model';

export const getCurrentUserChainName = (user: IUser, jwtInfo: IJwtInfo): string => {
  return user !== undefined && user != null && user.companies.find((userCompany) => userCompany.companyId === jwtInfo.companyId) ?
    user.companies.find((userCompany) => userCompany.companyId === jwtInfo.companyId).chainName
    :
    null;
};

export const isEciUser = (currentUserCompany: ICompany, currentUserChainName: string): boolean => {
  return (
    (currentUserCompany && currentUserCompany.reportCustomFieldSettingType === ReportCustomFieldSettingType.ECI)
    && (currentUserChainName && currentUserChainName.toLowerCase().startsWith('eci'))
  );
};

export const isEciImplant = (currentUser: IUser): boolean => {
  const isEciImplant = currentUser !== undefined && currentUser != null && currentUser.type == UserType.EXTERNAL && currentUser.email.toLowerCase().endsWith('@aitex.es') && isEciUser && currentUser.companies !== undefined && currentUser.companies != null && currentUser.companies.some(company => company.offices !== undefined && company.offices != null && company.offices.length > 0);

  return isEciImplant;
};
